import { Slate } from '@makeswift/controls'

export type EditableBlockKey = 'textAlign'
export type EditableBlockValue = Slate.ResponsiveBlockTextAlignment
